import { Button } from "./Button";
import { cn } from "../../utils/classMerger";
import SimpleTooltip from "./SimpleTooltip";

interface WizardNavigationProps {
    currentStep: number;
    totalSteps: number;
    onNext: () => void;
    onPrevious: () => void;
    onComplete: () => void;
    isNextDisabled?: boolean;
    isPreviousDisabled?: boolean;
    isCompleteDisabled?: boolean;
    /** Show Back on the first step too (the Add Post page's listing screen sits in front of it). */
    showPreviousOnFirstStep?: boolean;
    completeTooltip?: string;
    className?: string;
}

export default function WizardNavigation({
    currentStep,
    totalSteps,
    onNext,
    onPrevious,
    onComplete,
    isNextDisabled = false,
    isPreviousDisabled = false,
    isCompleteDisabled = false,
    showPreviousOnFirstStep = false,
    completeTooltip,
    className,
}: WizardNavigationProps) {
    return (
        <div
            className={cn(
                `w-full flex ${
                    currentStep > 0 || showPreviousOnFirstStep ? "justify-between" : "justify-end"
                }  items-center`,
                className
            )}
        >
            {(currentStep > 0 || showPreviousOnFirstStep) && (
                <Button onClick={onPrevious} disabled={isPreviousDisabled}>
                    Back
                </Button>
            )}

            {currentStep < totalSteps - 1 ? (
                <Button onClick={onNext} disabled={isNextDisabled}>
                    Continue
                </Button>
            ) : (
                <SimpleTooltip
                    message={completeTooltip ?? ""}
                    visible={isCompleteDisabled && !!completeTooltip}
                >
                    <Button onClick={onComplete} disabled={isCompleteDisabled}>
                        Schedule Posts
                    </Button>
                </SimpleTooltip>
            )}
        </div>
    );
}
